import { Injectable } from '@angular/core';

import * as _ from 'underscore';

@Injectable()
export class VnaPortalConfigDataParserService {

    constructor() {

    }

    getCallParametersToSend(data: Object): Object {
        let updateData: Object = {};
        updateData['call_range_allowed'] = { from: data['from'], to: data['to'] };
        updateData['call_requeue_time_ranges'] = data['requeue_ranges'];

        updateData['hours_to_add_out_of_range'] = {};
        data['hours_to_add_out_of_range'].forEach( (o) => {
            updateData['hours_to_add_out_of_range'][o['hour_call']] = o['hours_to_add'];
        });

        updateData['status_requeue'] = data['status_requeue'].map( (o) => {
            return o['value'];
        });

        return updateData;
    }

    getExternalCallbackParametersToSend(data: Object): Object {
        let updateData = Object.assign({}, data);

        if(_.isArray(data['status_to_send'])){
            updateData['status_to_send'] = data['status_to_send'].map( (o) => { return o['value'] } );
        }

        if(_.isArray(data['responses_to_send'])){
            updateData['responses_to_send'] = data['responses_to_send'].map( (o) => { return o['value'] });
        }

        delete updateData['url_vars'];
        delete updateData['manual_var'];
        return updateData;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/services/vna-portal-config-data-parser.service.ts